import * as React from 'react';

import { ResidenceCardData } from 'features/search/types';
import { HeadlineLevel } from 'features/ui/enums';
import { getLocalizedKvm } from 'features/services/utils/env-helper';

import { ContentTemplate } from './_contentTemplate';
import { getFormattedMessage } from 'features/services/utils/language-helper';

interface Props {
    premises: ResidenceCardData;
    level?: HeadlineLevel;
}

export const PremisesContent: React.FunctionComponent<Props> = ({ premises, level }) => {
    let description = getFormattedMessage('jm.components.QuickFacts.premisesNumber') + ' ' + premises.apartmentNumber;
    
    return (
        <ContentTemplate 
            residenceData={premises} 
            headline={getLocalizedKvm(premises.size)} 
            firstPrice='' 
            secondPrice=''
            description={description}
            level={level}
        />
    )
}